import _ from 'lodash';
import { useEffect } from 'react';

/**
 * Attach a value to the global `Swiper` key for debugging purposes,
 * automatically updating it when it changes and removing it when the
 * component that provided it is unmounted.
 *
 * @param {string} name - The key to be added to the `Swiper` object.
 * @param {any} value - The value to add.
 */
export function useDebug( name, value ) {
  const { Swiper } = _.defaults( window, { Swiper : {} } );
  useEffect( () => {
    Swiper[ name ] = value;
    return () => delete Swiper[ name ];
  }, [ Swiper, name, value ] );
}
